import React, { useEffect, useState } from 'react'
import AxiosInstance from 'utils/AxiosInstance'
import DefaultImage from 'assets/img/default-image.png'
import './style.css'
import moment from 'moment'
import {
  Card,
  CardBody,
  CardText,
  CardTitle,
  CardImg,
  CardFooter,
} from 'reactstrap'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { usePromotedCourses } from '../../Admin/usePromotedCourses'
import Loader from 'views/pages/Loader'

const PromotedCourse = () => {
  const courses = useSelector((state) => state.courses.courses)

  const {
    promotedCoursesData: { promotedCourses, loadingPromotedCourses },
  } = useSelector((state) => state.dashboard)

  usePromotedCourses()

  const filteredPromotedCourses = promotedCourses?.filter((course) =>
    courses.some((c) => c.id === course.id)
  )

  const getPromotedCourseImage = (course) => {
    return course?.image || DefaultImage
  }

  const firstPromotedCourse = filteredPromotedCourses?.at(0)

  return (
    <Card className='h-100'>
      {loadingPromotedCourses ? (
        <div
          className='text-center'
          style={{ marginTop: 'auto', marginBottom: 'auto' }}
        >
          <Loader color='default' />
        </div>
      ) : (
        <>
          {' '}
          {filteredPromotedCourses.length > 1 ? (
            <CardBody className='scrollbar' style={{ overflowY: 'scroll' }}>
              <CardTitle className='h2 mb-3'>Promoted Courses</CardTitle>
              {filteredPromotedCourses.map((course) => (
                <Link
                  key={course.id}
                  to={`/course/${course.id}`}
                  style={{ textDecoration: 'none', color: 'inherit' }}
                >
                  <div className='d-flex align-items-center mb-3 promoted-course'>
                    <CardImg
                      alt={course.name}
                      src={getPromotedCourseImage(course)}
                      style={{
                        width: '80px',
                        height: '80px',
                        objectFit: 'cover',
                        borderRadius: '4px',
                        marginRight: '15px',
                        padding: '5px',
                      }}
                    />
                    <div>
                      <h4 className='mb-1'>{course.name}</h4>
                      <small className='text-muted'>
                        {course?.first_name &&
                          `by ${course?.first_name} ${course?.last_name}`}
                        {course.version &&
                          ` on ${moment(course.version).format('Do MMMM')}`}
                      </small>
                    </div>
                  </div>
                </Link>
              ))}
            </CardBody>
          ) : filteredPromotedCourses.length === 1 ? (
            <Link to={`/course/${firstPromotedCourse?.id}`}>
              <CardImg
                alt='...'
                src={getPromotedCourseImage(firstPromotedCourse)}
                top
              />
              <CardBody>
                <CardTitle className='h2 mb-0'>
                  {filteredPromotedCourses[0].name}
                </CardTitle>
                <small className='text-muted'>
                  by{' '}
                  <small className='text-muted'>
                    {firstPromotedCourse?.first_name &&
                      `by ${firstPromotedCourse?.first_name} ${firstPromotedCourse?.last_name}`}
                    {firstPromotedCourse.version &&
                      ` on ${moment(firstPromotedCourse.version).format(
                        'Do MMMM'
                      )}`}
                  </small>
                </small>
                <CardText>{firstPromotedCourse.description} ...</CardText>
              </CardBody>
            </Link>
          ) : (
            <div className='h-100'>
              <CardImg alt='...' src={DefaultImage} top />
              <p className='text-center p-3'>No courses promoted.</p>
            </div>
          )}
        </>
      )}
    </Card>
  )
}

export default PromotedCourse
